export const elements = {
    searchField: document.querySelector("#search"),
    searchButton: document.getElementById("header-search-button"),
    hamburgerMenu: document.querySelector("#hamburger-menu"),
    mainNav: document.querySelector("#main-nav"),
    menuItems: document.querySelectorAll("#main-nav > ul > li"),
    subMenuItems: document.querySelectorAll("#main-nav > ul > li > ul > li > a"),
    popupBladeClose: document.querySelectorAll(".popup-blade > .popup-backdrop, .popup-blade .popup-close"),
    showPass: document.querySelectorAll(".password-control"),
    passwordFields: document.querySelectorAll("input[type=\"password\"]"),
    logoutBtns: document.querySelectorAll(".logoutBtn"),
    logoutPopup: document.getElementById("logout-popup"),
    app: document.getElementById("app"),
    csrfToken: document.querySelector("meta[name=csrf-token]").content,
    inputTokens: document.querySelectorAll("input[name=_token]"),
    historyGoBackBtns: document.querySelectorAll(".historyGoBack"),
    useTextTutorialsBtns: document.querySelectorAll(".useTextTutorials"),
    usePdfTutorialsBtns: document.querySelectorAll(".usePdfTutorials"),
    useSingleContentBtns: document.querySelectorAll(".useSingleContent"),
    useContentNewTabBtns: document.querySelectorAll(".useContentNewTab"),
    useContentBtns: document.querySelectorAll(".useContent"),
    buttonsDownloadContent: document.querySelectorAll(
        ".button-download-content, .button-add-package, .button-add-content"
    ),
    seoVideo: document.querySelector("#seoVideo"),
    seoVideoButton: document.querySelector("#seoVideoButton"),
    seoVideoCover: document.querySelector("#seoVideoCover"),
    translateRedirect: document.getElementById("translate-redirect")
}
